<template>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue